export default __webpack_public_path__ + "static/media/expandir-mas.f7cd5c1f.svg";